var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .blueprint_een{fill:#d1dcda;} "), /*#__PURE__*/React.createElement("path", {
    className: "blueprint_een",
    d: "M15,14H3v3h12V14z M14,16H4v-1h10V16z M6,21h16v-3H6V21z M7,19h14v1H7V19z M22,29h7v-3h-7V29z M23,27 h5v1h-5V27z M14,25h13v-3H14V25z M15,23h11v1H15V23z M31,5h-3V3c0-1.654-1.346-3-3-3s-3,1.346-3,3v2H10V3c0-1.654-1.346-3-3-3 S4,1.346,4,3v2H1C0.448,5,0,5.448,0,6v25c0,0.552,0.448,1,1,1h30c0.552,0,1-0.448,1-1V6C32,5.448,31.552,5,31,5z M24,3 c0-0.552,0.448-1,1-1s1,0.448,1,1v5c0,0.551-0.449,1-1,1s-1-0.449-1-1V3z M6,3c0-0.552,0.448-1,1-1s1,0.448,1,1v5 c0,0.551-0.449,1-1,1S6,8.551,6,8V3z M30,30H2V12h28V30z M30,11H2V7h3v1c0,1.105,0.895,2,2,2s2-0.895,2-2V7h14v1 c0,1.105,0.895,2,2,2s2-0.895,2-2V7h3V11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/Plan.6547c2bb28df5b659a0e831120e17c44.svg";
export { ForwardRef as ReactComponent };